const matchesErrorMessage = (error: Error | undefined, fragment: string) =>
  Boolean(error?.message?.toLowerCase().includes(fragment.toLowerCase()));

const isClosedLostOpportunityError = (error?: Error) =>
  matchesErrorMessage(
    error,
    "esigning can not be done on closed lost opportunities"
  );

const isSignatureInProgressError = (error?: Error) =>
  matchesErrorMessage(
    error,
    "esignature request is in progress or completed for the requested document"
  );

const isRepSolarLicenseRecordMissingEmployeeLegalNameError = (error?: Error) =>
  matchesErrorMessage(
    error,
    "the reps solar license record is missing the employee legal name"
  );

const isRepDoesNotHaveActiveSalesLicenseError = (error?: Error) =>
  matchesErrorMessage(error, "rep does not have an active sales license");

const isPrimaryRecipientEmailAddressInvalidError = (error?: Error) =>
  matchesErrorMessage(
    error,
    "the email address for the primary recipient is invalid"
  );

const isPrimaryAndSecondaryContactsSameError = (error?: Error) =>
  matchesErrorMessage(error, "primary and seconday contacts can't be the same");

const isInvalidProposalStageToVoidSelectedDocumentError = (error?: Error) =>
  matchesErrorMessage(
    error,
    "invalid proposal stage to void the selected document"
  );

const isKnownDocumentCardError = (error?: Error): boolean =>
  isClosedLostOpportunityError(error) ||
  isSignatureInProgressError(error) ||
  isRepSolarLicenseRecordMissingEmployeeLegalNameError(error) ||
  isRepDoesNotHaveActiveSalesLicenseError(error) ||
  isPrimaryRecipientEmailAddressInvalidError(error) ||
  isPrimaryAndSecondaryContactsSameError(error) ||
  isInvalidProposalStageToVoidSelectedDocumentError(error);

export { isKnownDocumentCardError };
